/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import '../../../index-6f6b9acc.js';
import { b as isFunction } from '../../../is-7fc17687.js';
import { extend } from '../index.js';
import '../../../_commonjsHelpers-56d33373.js';
import '../../../tslib.es6-e01eabb2.js';
import '../../env/index.js';
import '../../../index-f24a9ec1.js';
import '../../../index-892d8eee.js';
import '../register/index.js';
import '../../../bridges/dd/index.js';
import '../../../loadscripts-cf212b8d.js';
import '../../../constants-163bd007.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../bridges/windvane/index.js';
import '../../../bridges/nebula/index.js';
import '../../../index.es-142c5680.js';
import '../../../bridges/pangu-mini-app/index.js';
import '../../../log-aabf3a34.js';

/**
 * 插件管理器。统一管理跨端插件
 * @example
 * import { pluginManager } from '@alife/cn-uni-api';
 *
 * // 插件定义
 * const panguPlugin: UniApiPlugin = {
 *  api1: {
 *    xn: (options) => {},
 *    cn: (options) => {}
 *  },
 *  api2: {
 *    xn: (options) => {},
 *    cn: (options) => {}
 *  },
 * };
 *
 * // 插件加载
 * pluginManager.addPlugin(panguPlugin);
 * // 插件使用
 * pluginManager.api1({});
 */
var pluginManager = {
    addPlugin: function (plugin) {
        var _this = this;
        if (!plugin.$i) {
            Object.keys(plugin).forEach(function (apiName) {
                return _this.$registerApi(apiName, plugin[apiName]);
            });
            // @ts-ignore 只注册1次
            plugin.$i = true;
        }
    },
    $registerApi: function (key, value) {
        // plugin有效性检测
        if (!key) {
            console.error('【@alife/cn-uni-api】插件注册无效', value);
            return;
        }
        var apiFunc = isFunction(value) ? value : extend(value);
        // @ts-ignore 直接挂载到this上面。
        this[key] = apiFunc;
    },
};

export { pluginManager };
